import * as React from "react";
import FadingElement from "../animation/fading-element/fading-element";
import styled from "styled-components";
import { GoogleAnalyticsEventType } from "../../models/google-analytics";
import * as googleAnalyticsService from "../../services/google-analytics-service";

/** IntroStepSelectBlockElementSelectorData */

interface IntroStepSelectBlockElementSelectorData {
  /** TYTUŁ FEATERA */
  elementSelectorTitle: string

  /** TEKST OPISU FEATERA */
  elementSelectorDescription: string | string[]
}

/** IntroStepSelectBlockElementSelectorProps */

interface IntroStepSelectBlockElementSelectorProps extends IntroStepSelectBlockElementSelectorData {
  activeElementOrdinal: number
  elementOrdinal: number
  selectElement: (elementNumber: number) => any
}

const IntroStepSelectBlockElementSelector = (props: IntroStepSelectBlockElementSelectorProps) => {
  const {activeElementOrdinal,elementOrdinal,selectElement,elementSelectorTitle} = props;
  const elementIsActive: boolean = activeElementOrdinal == elementOrdinal;
  return (
    <li className={elementIsActive ? "active" : ""} onClick={() => selectElement(elementOrdinal)}>
      <StyledLink data-tab-is-active={elementIsActive}>
        <StyledSpan className="badge" data-tab-is-active={elementIsActive}>{elementOrdinal}</StyledSpan>
        {elementSelectorTitle}
      </StyledLink>
    </li>
  )
};

/** IntroStepSelectBlock */

interface IntroStepSelectBlockProps {
  /** ELEMENTY DO WYŚWIETLENIA */
  stepSelectElements: IntroStepSelectBlockElementSelectorData[]

  /** GOOGLE EVENT TO TRIGGER ON SECTION VIEW */
  componentViewEventType?: GoogleAnalyticsEventType

  /** GOOGLE EVENT TO TRIGGER ON ELEMENT SELECT */
  elementSelectEventType?: GoogleAnalyticsEventType
}

interface IntroStepSelectBlockState {
  activeTabIndex: number
}

class IntroStepSelectBlock extends React.Component<IntroStepSelectBlockProps,IntroStepSelectBlockState> {

  constructor(props: IntroStepSelectBlockProps) {
    super(props);
    this.state = {
      activeTabIndex: 1
    };
    this.onComponentView = this.onComponentView.bind(this);
    this.onElementSelect = this.onElementSelect.bind(this);
  }

  onComponentView() {
    if (this.props.componentViewEventType) {
      googleAnalyticsService.trackEvent(this.props.componentViewEventType);
    }
  }

  onElementSelect(elementOrdinal: number) {
    // SELECTING ELEMENT
    this.setState({activeTabIndex: elementOrdinal});

    // GOOGLE EVENT
    if (this.props.elementSelectEventType) {
      googleAnalyticsService.trackEvent(this.props.elementSelectEventType);
    }
  }

  renderElementDescription(elementDescription: string | string[]) {
    // SPRAWDZANIE CZY ELEMENT DESCRIPTION JEST LISTĄ
    const elementDescriptionIsArray: boolean = Array.isArray(elementDescription);

    // ZWRACANIE DANYCH
    return (
      <div>
        {!elementDescriptionIsArray && <p>{elementDescription}</p>}
        {elementDescriptionIsArray && (elementDescription as string[]).map((elementDescriptionPart: string, i: number) => <p key={i}>{elementDescriptionPart}</p>)}
      </div>
    )
  }

  render() {
    const {stepSelectElements} = this.props;
    const {activeTabIndex} = this.state;
    return (
      <div className="goodgrowth-theme-styles" onMouseEnter={this.onComponentView}>
        <IntroStepSelectBlockWrapper className="content">
          <div className="row">
            <div className="col-sm-12">

              <div className="tabbable bigtabs tabs-top-horizontal">

                <ul className="nav nav-tabs">
                  {stepSelectElements.map((element: IntroStepSelectBlockElementSelectorData, index: number) =>
                    <IntroStepSelectBlockElementSelector
                      key={index}
                      activeElementOrdinal={activeTabIndex}
                      elementOrdinal={index + 1}
                      selectElement={this.onElementSelect}
                      {...element}
                    />
                  )}
                </ul>

                <FadingElementTabContentWrapper className="tab-content" style={{borderTop:"1px solid #03a9f4"}}>
                  {stepSelectElements.map((element: IntroStepSelectBlockElementSelectorData, index: number) =>
                    <FadingElement in={activeTabIndex == index + 1} key={index}>
                      <div className={activeTabIndex == index + 1 ? "tab-pane fade active in" : "tab-pane fade"}>
                        <h4>{element.elementSelectorTitle}</h4>
                        {this.renderElementDescription(element.elementSelectorDescription)}
                      </div>
                    </FadingElement>
                  )}
                </FadingElementTabContentWrapper>

              </div>
            </div>
          </div>
        </IntroStepSelectBlockWrapper>
      </div>
    )
  }

}

/** STYLES */

const IntroStepSelectBlockWrapper = styled.section`
  .active:after {
    border-top-color: #03a9f4 !important;
  }
`;

const FadingElementTabContentWrapper = styled.div`
  @media (min-width : 993px) {
    height: 330px;
  }
  @media (max-width : 800px) {
    height: 380px;
  }
  @media (max-width : 600px) {
    height: 450px;
  }
  @media (max-width : 550px) {
    height: 500px;
  }
  @media (max-width : 550px) {
    height: 600px;
  }
`;

const StyledSpan = styled.span`
  font-family: 'Roboto', sans-serif !important;
  font-size: 20px !important;
  min-width: 0 !important;
  border-radius: 15% !important;
  padding-top: 0px !important;
  &[data-tab-is-active~="true"] {
    color: #03a9f4 !important;
  }  
  &[data-tab-is-active~="false"] {
    background: #03a9f4 !important;
    color: white;
  }
  float: none !important;
`;

const StyledLink = styled.a`
  font-weight: bold !important;
  :hover {
    background: #03a9f4 !important;
    span {
      background: white !important;
      color: #03a9f4 !important;
    }
  }
  &[data-tab-is-active~="true"] {
    background: #03a9f4 !important;
  }
`;

export default IntroStepSelectBlock


// WEBPACK FOOTER //
// ./src/layouts/intro-step-select-block/intro-step-select-block.tsx